export default {
  getChains: state => state.chains,
  getChainsLoading: state => state.chainsLoading,
  getChainsLoaded: state => state.chainsLoaded,
  getChainByKey: state => key => state.chains.find(chain => chain.key === key) || null,
  // Icon URL by chain key, from either list: the history filter draws chains
  // that are momentarily down. Built once per list change, since a selector
  // asks for every one of several hundred chains.
  getChainIconByKey: state =>
    [...state.allChains, ...state.chains].reduce((icons, chain) => {
      if (chain.icon) icons[chain.key] = chain.icon
      return icons
    }, {}),
}
